/**
 * 客户端插件：兜底修复 cookie 域名
 * 扫描所有 cookie，将非主域的 cookie 迁移到主域（如 .wikibit.com）
 */
import { fixCookieDomain } from '../utils/cookieDomain'

export default defineNuxtPlugin(() => {
  // 在客户端初始化时执行一次兜底修复
  if (import.meta.client) {
    fixCookieDomain()
  }
})
